const config = {
    APP_NAME: "MyUhl inc",
    API_ROOT: process.env.REACT_APP_BASE_URL,
    DEFAULT_LANG_CODE: "en",
};

export default config;
